export * from './upload-file.component';
